/**
 * 3点ローディングインジケーター
 * セッション復元時やメッセージ待機時に使用
 */

import { Box, type BoxProps } from '@chakra-ui/react';

type TypingIndicatorProps = BoxProps;

const dotStyle = {
  w: 2,
  h: 2,
  borderRadius: 'full',
  bg: 'gray.400',
} as const;

export const TypingIndicator = (props: TypingIndicatorProps) => {
  return (
    <Box display="flex" alignItems="center" gap={1} py={2} {...props}>
      <Box {...dotStyle} animation="typingBounce" animationDelay="0s" />
      <Box {...dotStyle} animation="typingBounce" animationDelay="0.2s" />
      <Box {...dotStyle} animation="typingBounce" animationDelay="0.4s" />
    </Box>
  );
};
